/*
 * IMPORTS
 */
import { gql } from '@apollo/client'

/*
 * EXPORTS
 */

export default gql`
  mutation DeleteDataMutation(
    $startDate: String!
    $endDate: String!
    $tableName: String!
    $type: DeleteType!  
  ) {
    DeleteData(
      startDate: $startDate
      endDate: $endDate
      tableName: $tableName
      type: $type
    ) {
      message
      status
    }
  }
`
